var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: " http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 75.5,
    rx: 186,
    id: "svg_2",
    cy: 416.5,
    cx: 250,
    stroke: "#000",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 75.5,
    rx: 186,
    id: "svg_1",
    cy: 83.5,
    cx: 250,
    stroke: "#000",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000",
    id: "svg_3",
    y2: 421,
    x2: 64,
    y1: 85.99999,
    x1: 64,
    strokeWidth: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000",
    id: "svg_4",
    y2: 422,
    x2: 436,
    y1: 86,
    x1: 436,
    strokeWidth: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_10",
    height: 257,
    width: 362.00002,
    y: 164,
    x: 68.99999,
    strokeWidth: 0,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 75.5,
    rx: 186,
    id: "svg_12",
    cy: 352.5,
    cx: 250,
    stroke: "#000",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_13",
    height: 185,
    width: 362.00002,
    y: 164,
    x: 68.99999,
    strokeWidth: 0,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 75.5,
    rx: 186,
    id: "svg_14",
    cy: 249.5,
    cx: 250,
    stroke: "#000",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_15",
    height: 167,
    width: 362.00002,
    y: 81,
    x: 68.99999,
    strokeWidth: 0,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 75.5,
    rx: 186,
    id: "svg_11",
    cy: 83.5,
    cx: 250,
    stroke: "#000",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 62.5,
    rx: 170.5,
    id: "svg_16",
    cy: 83.5,
    cx: 250,
    strokeWidth: 2,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCan);
export default __webpack_public_path__ + "static/media/Can.da464eb9fec5dd7ad54c24b61fc1a86e.svg";
export { ForwardRef as ReactComponent };